
<oe-flat-widget [title]="imageTitle0" [icon]="{name: 'oe-sp', color:'environmental'}">
  <img [src]="imageData0" alt="Logo" class="image-container">
</oe-flat-widget>





